module.exports = __webpack_public_path__ + "static/media/pla_clear_gaint_straw3.db62884c.png";